import axios from "axios";
import {SMR_ENDPOINT} from '../../constants';

export default {
    getPage: function (slug) {
        return axios.get(SMR_ENDPOINT + '/pages/' + slug).then(response => {
            return response;
        })
    }
}